// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Filter = React.forwardRef(function Filter(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Filter" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M2 5H22V7.5H2V5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 10.5H18V13H6V10.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M14.5 16H10V18.5H14.5V16Z", fill: "currentColor" }))));
});
Filter.displayName = 'Filter';
export default Filter;
//# sourceMappingURL=Filter.js.map